import { all } from 'route-data/all';
import { conditional } from 'route-data/conditional';
import { withFeatureFlag } from 'route-data/with-feature-flag';
import { exceptWhenLoggedOut } from 'route-data/except-when-logged-out';
import { shopByListEligibilityFetcher } from 'redux/fetchers/shop-by-list-eligibility';
import cmsExperienceFragment from 'redux/fetchers/experience-fragment';
import { MIDDLE_MEGA_MENU, SEASONAL_MENU } from 'constants/experience-fragments';
import { getTaxonomy } from 'redux/modules/taxonomy/actions';
import { getIsTaxonomyLoaded } from 'redux/modules/taxonomy/selectors';

const shouldGetTaxonomy = (_args: unknown, getState: WtrGetState) =>
  !getIsTaxonomyLoaded(getState());

export const menuFetcher = all(
  conditional(shouldGetTaxonomy, getTaxonomy),
  cmsExperienceFragment(MIDDLE_MEGA_MENU.key, { numberOfRetries: 2, cache: false }),
  cmsExperienceFragment(SEASONAL_MENU.key, { numberOfRetries: 2, cache: false }),
  withFeatureFlag(
    'agenticShopping_enableListToBasket',
    exceptWhenLoggedOut(shopByListEligibilityFetcher),
  ),
);
